import { defineMessages } from 'react-intl'

const scope =
  'procurify.platform.globalSearch.GlobalSearchUnsupportedQueryState'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Try a different search',
  },
  content: {
    id: `${scope}.content`,
    defaultMessage:
      "To get started, try searching for a name, a document ID, or a specific item {br}you're looking for.",
  },
})
